import { ChangeDetectionStrategy, Component, Input, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { BlockMargin } from '@service/article/article.service';
import { MarginService } from '../margin.service';

interface LinkBlockInterface
{
  type: string,
  textContent: {
    blocks: Array<BlockInterface>
  }
}

interface BlockInterface
{
  heading: string,
  headingLink: string,
  headingLinkDescription: string
}

@Component({
    selector: 'app-link-block',
    templateUrl: './link-block.component.html',
    styleUrls: ['./link-block.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LinkBlockComponent implements OnInit
{

  @Input() section: LinkBlockInterface;
  @Input() margin: BlockMargin;

  constructor(public changeDet: ChangeDetectorRef, public marginService: MarginService) { }

  ngOnInit(): void
  {
  }

  @HostListener('window:resize', ['$event'])
  public onWindowResize($event): void
  {
    this.changeDet.detectChanges();

  }
}
